import type { AgentState } from "@livekit/components-react";

/** An Extended Thinking utterance may finish before the overall task does. */
export function extendedInteractionState(
  state: AgentState,
  attributes?: Readonly<Record<string, string>>
): AgentState {
  return state === "listening" &&
    attributes?.["chickytutor.runtime"] === "main3geminicode" &&
    attributes["chickytutor.interaction"] === "IN_PROGRESS"
    ? "thinking"
    : state;
}
